import ReleasePhase from 'components/framework/models/ReleasePhase';
import RecordFields from '../RecordFields';
import { registerRecordFieldsClasses } from './index';

export default class ReleasePhaseFields extends RecordFields {
  static modelClass = ReleasePhase;
}

registerRecordFieldsClasses({ ReleasePhaseFields });
